import React, { useEffect, useState, useContext, useRef } from 'react'
import Story from './Story'
import useInterval from './UseInterval'
import useScrollListener from './useScrollListener'
import { makeStyles } from '@material-ui/core'
import ProgressDialog from './ProgressDialog'
import DisplayOptionContext from './context/DisplayOptionContext'

const useStyles = makeStyles({
  stories: {
    "&:focus": {
      outline: 'none',
    },
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  }
})

function getClosestWidth() {
  let currentViewportWidth = window.innerWidth

  let least
  let currentDelta

  const VIEWPORT_WIDTHS = [100, 300, 500, 750, 1000, 1500, 2500]

  VIEWPORT_WIDTHS.forEach(width => {
    const delta = Math.abs(width - currentViewportWidth)
    if (!currentDelta || delta < currentDelta) {
      currentDelta = delta
      least = width
    }
  })

  return least
}

export default function StoriesMain(props) {
  const { api, app, viewClicked, isMobile } = props
  const exhibitId = app._id
  const order = app.storiesOrder

  const classes = useStyles()

  const displayOption = useContext(DisplayOptionContext)

  const [stories, setStories] = useState([])
  const [direction, setDirection] = useState(1)
  const [storyToFlipID, setStoryToFlipID] = useState('')
  const [totalNoOfStories, setTotalNoOfStories] = useState(0)
  const [showProgress, setShowProgress] = useState(true)
  const [noMoreStories, setNoMoreStories] = useState(false)
  const [squareWidth, setSquareWidth] = useState(undefined)
  const [fetching, setFetching] = useState(false)

  const getPageOfStories = useRef()

  useEffect(() => {
    const pager = api.story().getPager({exhibitId, order, limit: 35})
    getPageOfStories.current = pager.getPageOfStories
  }, [api, exhibitId])


  const DELAY_BEFORE_FLIPPING_STORY = 5000

  useEffect(() => {
    const width = getClosestWidth()
    let height = window.innerHeight
    let noOfRows;
    let noOfSquaresPerRow;
    let squareWidth;
    if (width < 860) {
      // 2 squares in the row i.e. 50% in Story.css
      noOfSquaresPerRow = 2;
      squareWidth = Math.round(width / noOfSquaresPerRow);
      noOfRows = Math.round(height / squareWidth);
    } else if (width > 860 && width < 960) {
      noOfSquaresPerRow = 3
      squareWidth = Math.round(width / noOfSquaresPerRow);
      noOfRows = Math.round(height / squareWidth);
    } else if (width > 960 && width < 1025) {
      noOfSquaresPerRow = 4
      squareWidth = Math.round(width / noOfSquaresPerRow);
      noOfRows = Math.round(height / squareWidth);
    } else {
      noOfSquaresPerRow = 5
      squareWidth = Math.round(width / noOfSquaresPerRow);
      noOfRows = Math.round(height / squareWidth);
    }

    setSquareWidth(squareWidth)
  }, [exhibitId])

  const getStories = async () => {
    if(noMoreStories) {
      return
    }

    setFetching(true)
    setShowProgress(true)
    const newStories = await getPageOfStories.current()

    if(newStories.length === 0) {
      setNoMoreStories(true)
    }

    const copy = [...stories, ...newStories]
    copy.forEach(s => s.flip = false)

    setStories(copy)
    setFetching(false)
    setShowProgress(false)
  }

  useEffect(() => {
    if(!exhibitId) return
    getStories()
  }, [exhibitId])

  useScrollListener((passedStopAutoScroll) => {
    getStories()
  })

  useInterval(
    () => {
      handleFlip()
    },
    DELAY_BEFORE_FLIPPING_STORY,
    direction
  )

  const handleFlip = () => {
    if (fetching) {
      return
    }

    const copy = [...stories]
    if (storyToFlipID) {
      let prevStory = copy.find((s) => s._id === storyToFlipID)
      prevStory.flip = !prevStory.flip
    }

    if (stories.length === 0) return

    let rand = Math.floor(Math.random() * stories.length);
    let story = copy[rand];

    setStoryToFlipID(story._id);
    story.flip = !story.flip;
    setStories(copy);
  }

  return (
    <div
      tabIndex={0} // for onKeyDown to work
      className={classes.stories}
    >
      {stories.map((story, index) => (
        <Story
          key={index}
          api={api}
          story={story}
          flip={story.flip}
          viewClicked={viewClicked}
          isMobile={isMobile}
          displayOption={displayOption}
        />
      ))}
      <ProgressDialog show={showProgress} height={squareWidth} />
      <div
        style={{
          display: 'flex',
          width: `100%`,
          justifyContent: `center`,
          height: 60,
          alignItems: `center`,
          fontSize: 20,
        }}
      >
        No more stories to show
      </div>
    </div>
  )
}
